import Typography, { TypographyProps } from '@mui/material/Typography';
import { memo, useCallback } from 'react';

interface LinkableTextProps extends Omit<TypographyProps, 'onClick'> {
  href: string;
  children: React.ReactNode;
}

/**
 * A text component that opens a URL in a new tab when clicked.
 * Shows underline on hover with pointer cursor.
 */
const LinkableText = memo(function LinkableText({
  href,
  children,
  sx,
  ...typographyProps
}: LinkableTextProps) {
  const handleClick = useCallback(() => {
    window.open(href, '_blank');
  }, [href]);

  return (
    <Typography
      {...typographyProps}
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        '&:hover': {
          textDecoration: 'underline',
        },
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
});

export default LinkableText;
